import { useMemo } from 'react';
import { useAuth } from '../../../../context/AuthContext';

export const useProjectPermissions = () => {
  const { user } = useAuth();

  return useMemo(() => {
    const role = user?.role;

    const isAdmin = role === 'admin' || role === 'Director';
    const isCommercial = ['commercial_manager', 'commercial_staff'].includes(role);
    const isProjectManager = role === 'project_manager';
    const isCustomer = role === 'customer';

    const canEdit = isAdmin || isCommercial;
    const canDownloadSubconOpname = !!user && !isCustomer;
    const canViewGantt = !!user && !isCustomer;

    return {
      user,
      role,
      isAdmin,
      isCommercial,
      isProjectManager,
      isCustomer,
      canEdit,
      canDownloadSubconOpname,
      canViewGantt
    };
  }, [user]);
};
